import React from "react";
import styles from "./DigitalFeature.module.css";
import { Link } from "react-router-dom";
export default function DigitalFeature({
  title = "Connecting you with your digital",
  highlight = "future.",
  subtitle = `Shak7 is your partner for modern, result-oriented digital marketing.
We create engaging content, smart ad campaigns, and optimized strategies that drive conversions.
Let’s turn your brand into a digital leader.`,
  pillA = "Smart Growth for Your Business",
  pillB = "Boost Your Online Presence",
  primaryText = "View Our Work",
  ghostText = "Clone this layout",
}) {
  return (
    <section className={styles["df-root"]} id="digitalfeatureSection" >
      {/* Decorative background (scoped to this section) */}
      <div className={styles["df-bg"]} aria-hidden="true"></div>

      <div className={styles["df-wrapper"]} >
        <div className={styles["df-section"]} >
          {/* LEFT: TEXT */}
          <div className={styles["df-text"]}>
            <div className={styles["df-eyebrow"]}>
              <span className={styles["df-eyebrow-dot"]}></span>
              {/* <span>Next-gen web experiences</span> */}
            </div>

            <h2 className={styles["df-title"]}>
              {title} <span>{highlight}</span>.
            </h2>

            <p className={styles["df-subtitle"]}>
              {subtitle.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < subtitle.split("\n").length - 1 && <br />}
                </React.Fragment>
              ))}
            </p>

            <div className={styles["df-meta"]}>
              <div className={styles["df-meta-pill"]}>
                <span className={styles["df-meta-pill-dot"]}></span>
                {pillA}
              </div>
              <div className={styles["df-meta-pill"]}>
                <span className={styles["df-meta-pill-dot"]}></span>
                {pillB}
              </div>
            </div>

            <div className={styles["df-actions"]}>
              <Link to="/potfolio" className={styles["df-btn-primary"]}>
                <span>{primaryText}</span>
                <span className={styles["df-btn-icon"]}>▶</span>
              </Link>


            </div>
          </div>

          {/* RIGHT: ORBIT CARD */}
          <div className={styles["df-visual"]}>
            <article className={styles["df-orbital-card"]}>
              <div className={styles["df-orbital-card-inner"]}>
                <div className={styles["df-card-badge"]}>
                  <span className={styles["df-card-badge-dot"]}></span>
                  <span style={{color:'white'}}>View Our Work </span>
                </div>

                <div className={styles["df-card-orb"]}>
                  <div className={styles["df-orb-node"]}></div>
                  <div className={styles["df-orb-node"]}></div>
                  <div className={styles["df-orb-node"]}></div>
                  <div className={styles["df-orb-node"]}></div>
                </div>

                <footer className={styles["df-card-footer"]}>
                  <div className={styles["df-card-footer-top"]}>
                    <div>
                      <div className={styles["df-card-label"]}>Marketing Focus</div>
                      <div className={styles["df-card-stat"]}>Branding · SEO · Ads</div>
                    </div>
                    <div>
                      <div className={styles["df-card-label"]}>Impact Level</div>
                      <div className={styles["df-card-stat"]}>High Growth</div>
                    </div>
                  </div>
                  <div className={styles["df-card-progress"]}>
                    <div className={styles["df-card-progress-fill"]}></div>
                  </div>
                </footer>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
